import React from 'react'
import { useState } from 'react';
import {Navigate , useLocation} from 'react-router-dom'
const UserProtected = ({user,children}) => {

  return user ?children :  <Navigate to="/login"/>
      
   
  
}

export default UserProtected
